import { IBlogCategoryState } from "../../types/blogCategoryTypes";
import {
  GET_CATEGORIES,
  GET_SUB_CATEGORIES,
  GET_SUB_CATEGORIES_DETAILS,
  RESET_SUB_CATEGORIES_DETAILS,
  SET_CATEGORY_LIST_STATUS,
} from "../constants/blogCategoryConstants";

const init: IBlogCategoryState = {
  mainCategories: [],
  subCategories: {
    paginate: 25,
    total: 0,
    data: [],
    per_page: 25,
  },
  subCategoryDetail: null,
  listStatus: false,
  detailStatus: false,
};

const blogCategoryReducer = (state: IBlogCategoryState = init, action: any): IBlogCategoryState => {
  switch (action.type) {
    case GET_SUB_CATEGORIES: {
      return {
        ...state,
        subCategories: action.payload.data,
        listStatus: true,
      };
    }
    case GET_CATEGORIES: {
      return {
        ...state,
        mainCategories: action.payload.data,
      };
    }
    case SET_CATEGORY_LIST_STATUS: {
      return {
        ...state,
        listStatus: false,
      };
    }
    case GET_SUB_CATEGORIES_DETAILS: {
      return {
        ...state,
        subCategoryDetail: action.payload.data,
        detailStatus: true,
      };
    }
    case RESET_SUB_CATEGORIES_DETAILS: {
      return {
        ...state,
        subCategoryDetail: null,
        detailStatus: false,
      };
    }
    default:
      return state;
  }
};
export default blogCategoryReducer;
